"use strict";
(self.webpackChunksabai_design = self.webpackChunksabai_design || []).push([
  [564],
  {
    7749: function (t, e, n) {
      var l = n(7350),
        i = n.n(l);

      // 2026-09-29: clicking a tab scrolled to the right section but could
      // underline a different one -- click FAQ, land on FAQ, watch "Materials"
      // light up.
      //
      // The click handler never claimed the underline. It called
      // window.scrollTo({ behavior: "smooth" }) and left the active tab
      // entirely to handleOnScroll, which is throttled at 250ms and simply
      // samples wherever the animation happens to be when it runs. Clicking a
      // tab from further down the page means the first sample fires while the
      // page is still near where it started, so the tab for THAT position wins.
      // Normally a later sample corrects it, but lodash throttle only schedules
      // its trailing call when the function was invoked during the wait window
      // -- so when the animation's last scroll event lands on a window
      // boundary, the mid-flight sample is the final word and the wrong tab
      // stays underlined. Intermittent, because it depends on where the click
      // started and how the animation lines up with the throttle clock.
      //
      // The clicked tab is now the authority: it is underlined immediately and
      // held until the page stops moving, so no mid-animation sample can
      // override it.
      //
      // Two related weaknesses hardened at the same time. Neither is confirmed
      // to fire on the current templates, but both produce the same symptom:
      //
      //   * handleOnScroll activates the LAST target whose top has passed the
      //     tab bar, and getBoundingClientRect() reports an all-zero rect for
      //     an element that is display:none or detached from the document.
      //     Zero reads as "already scrolled past", so one such element low in
      //     the list outranks every real section above it. Those are skipped.
      //
      //   * The target list was captured once in connectedCallback. A section
      //     re-rendered after that left a detached node behind and every tab
      //     below it pointing at the wrong index. The list is re-read when a
      //     detached node shows up, and each tab's index is resolved from its
      //     own scroll id rather than the position it held at startup.

      class o extends HTMLElement {
        connectedCallback() {
          this.syncScrollTargets(true);
          this.handleOnFirstLoad();

          // Registered straight away, not inside the timeout below: a tab can
          // be clicked before that fires, and the lock needs this to know the
          // page is still moving.
          this.onScrollRaw = () => {
            if (this.lockedIndex != null) this.armIdleRelease();
          };
          window.addEventListener("scroll", this.onScrollRaw, { passive: true });

          setTimeout(() => {
            this.handleOnScroll();
            this.throttledHandleOnScroll = i()(this.handleOnScroll.bind(this), 250);
            window.addEventListener("scroll", this.throttledHandleOnScroll);
            window.addEventListener("resize", this.throttledHandleOnScroll);
          }, 250);
        }

        disconnectedCallback() {
          window.removeEventListener("scroll", this.throttledHandleOnScroll);
          window.removeEventListener("resize", this.throttledHandleOnScroll);
          window.removeEventListener("scroll", this.onScrollRaw);
          this.releaseActiveHeading();
        }

        // Reads every [data-scroll-id] in document order and gives each tab the
        // index of its own target. Safe to call repeatedly; pass true once to
        // bind the click handlers.
        syncScrollTargets(bind) {
          this.scrollContentEls = [...document.querySelectorAll("[data-scroll-id]")];
          const ids = this.scrollContentEls.map((el) => el.getAttribute("data-scroll-id"));

          if (!bind) {
            this.scrollHeadingEls.forEach((heading) => {
              const index = ids.indexOf(heading.getAttribute("href"));
              if (index >= 0) heading._contentIndex = index;
            });
            return;
          }

          this.scrollHeadingEls = [...this.querySelectorAll("[data-scroll-heading]")]
            .map((heading) => {
              const index = ids.indexOf(heading.getAttribute("href"));
              if (index < 0) {
                heading.classList.add("hidden");
                return;
              }
              heading._contentIndex = index;
              heading.addEventListener("click", (event) => {
                event.preventDefault();
                this.scrollToHeading(heading);
              });
              return heading;
            })
            .filter(Boolean);
        }

        scrollToHeading(heading) {
          this.syncScrollTargets(false);

          const index = heading._contentIndex;
          const target = this.scrollContentEls[index];
          if (!target) return;

          this.lockedIndex = index;
          this.setActiveHeading(index);
          this.lockActiveHeading();

          window.scrollTo({
            top:
              window.scrollY +
              target.getBoundingClientRect().top -
              this.getBoundingClientRect().bottom,
            behavior: "smooth",
          });
        }

        // Released 150ms after the last scroll event, so the lock lasts exactly
        // as long as the animation does. The 2s cap covers the case where the
        // page is already at the target and no scroll event ever arrives.
        lockActiveHeading() {
          clearTimeout(this.lockCapTimer);
          this.lockCapTimer = setTimeout(() => this.releaseActiveHeading(), 2000);
          this.armIdleRelease();
        }

        armIdleRelease() {
          clearTimeout(this.idleTimer);
          this.idleTimer = setTimeout(() => this.releaseActiveHeading(), 150);
        }

        releaseActiveHeading() {
          clearTimeout(this.idleTimer);
          clearTimeout(this.lockCapTimer);
          this.lockedIndex = null;
        }

        handleOnFirstLoad() {
          const hash = window.location.hash;
          if (!hash) return;
          if ("scrollRestoration" in history) history.scrollRestoration = "manual";
          const id = hash.slice(1);
          const index = this.scrollContentEls?.findIndex((el) => el.dataset.scrollId === id);
          const target = this.scrollContentEls[index];
          if (target) {
            target.scrollIntoView({ behavior: "instant" });
            this.setActiveHeading(index);
          }
        }

        handleOnScroll() {
          if (this.lockedIndex != null) return;

          if (this.scrollContentEls.some((el) => !el.isConnected)) this.syncScrollTargets(false);

          const barBottom = this.getBoundingClientRect().bottom;
          let active = 0;

          this.scrollContentEls.forEach((el, index) => {
            // display:none and detached elements both report an all-zero rect,
            // which would otherwise read as "already scrolled past".
            if (!el.isConnected) return;
            const rect = el.getBoundingClientRect();
            if (rect.width === 0 && rect.height === 0) return;
            if (rect.top <= barBottom) active = index;
          });

          this.setActiveHeading(active);
        }

        setActiveHeading(t) {
          this.scrollHeadingEls.forEach((heading) => {
            const isActive = heading._contentIndex === t;
            heading.dataset.active = Boolean(isActive).toString();
            if (isActive) this.scrollHeadingToView(heading);
          });
        }

        scrollHeadingToView(t, e = "smooth") {
          const headingRect = t.getBoundingClientRect();
          const barRect = this.getBoundingClientRect();
          if (headingRect.left >= barRect.left && headingRect.right <= barRect.right) return;
          const delta =
            headingRect.left - barRect.left - parseFloat(getComputedStyle(this).paddingLeft);
          const max = this.scrollWidth - this.clientWidth;
          const left = Math.min(Math.max(this.scrollLeft + delta, 0), max);
          this.scrollTo({ left, behavior: e });
        }
      }

      customElements.get("tab-redesign-v2") || customElements.define("tab-redesign-v2", o);
    },
  },
  function (t) {
    t.O(0, [223], function () {
      return (e = 7749), t((t.s = e));
      var e;
    });
    t.O();
  },
]);
